/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import { makeStyles } from '@material-ui/core/styles'
import { isFunction } from 'lodash'
import React from 'react'
import { WidgetProps } from 'react-jsonschema-form'

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.grey['800'],
    fontSize: 14,
    lineHeight: 20 / 14,
  },
}))

const RadioWidget = ({
  id,
  schema,
  options,
  value,
  required,
  disabled,
  readonly,
  label,
  onChange,
  onBlur,
  onFocus,
}: WidgetProps) => {
  const enumOptions: { label: string; value: string }[] = Array.isArray(options.enumOptions)
    ? options.enumOptions
    : []
  const enumDisabled: string[] = Array.isArray(options.enumDisabled) ? options.enumDisabled : []

  const handleChange = (_e: React.ChangeEvent<HTMLInputElement>, targetValue: string) =>
    isFunction(onChange) &&
    onChange(schema.type === 'boolean' ? targetValue !== 'false' : targetValue)
  const handleBlur = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onBlur) && onBlur(id, targetValue)
  const handleFocus = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onFocus) && onFocus(id, targetValue)

  const classes = useStyles()

  return (
    <FormControl fullWidth margin="normal" required={required}>
      <FormLabel className={classes.label} htmlFor={id} required={false}>
        {label || schema.title}
      </FormLabel>
      <RadioGroup
        name={id}
        row={!!options.inline}
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        value={`${value}`}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
      >
        {enumOptions.map(option => {
          const itemDisabled = enumDisabled.includes(option.value)
          return (
            <FormControlLabel
              key={option.value}
              classes={{ label: classes.label }}
              control={<Radio key={option.value} color="secondary" required={required} />}
              disabled={disabled || itemDisabled || readonly}
              label={option.label}
              value={option.value}
            />
          )
        })}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioWidget
